import { render, staticRenderFns } from "./DimitraModuleDetailDialog.vue?vue&type=template&id=1ef73136&scoped=true"
import script from "./DimitraModuleDetailDialog.vue?vue&type=script&lang=js"
export * from "./DimitraModuleDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./DimitraModuleDetailDialog.vue?vue&type=style&index=0&id=1ef73136&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef73136",
  null
  
)

export default component.exports